import React, { useEffect, useState } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DashboardChart from "./components/DashboardChart";
import { getStudentMoods } from "../../crud/api/mood.crud";
import { setLoader } from "../../../redux/ducks/load.duck";
import DashboardTitle from "./components/DashboardTitle";
import TeamsList from "./components/TeamsList";
import RotatedBackground from "./components/RotatedBackground";
import DashboardCardList from "./components/DashboardCardList";
import TeleHelpNotifications from "./components/TelehelpNotifications";
import TeleHelpNotificationsSentCount from "./components/TeleHelpNotificationsSentCount";
import DashboardLibraryList from "./components/DashboardLibraryList";
import DashboardUniversityHub from "./components/DashboardUniversityHub";
import { useBreakpoints } from "../../hooks/useBreakpoint";
import DashboardFocusAreasListTop3 from "./components/DashboardFocusAreasListTop3";
import { useTraduction } from "../../hooks/useTraduction";
import DashboardDownloadDropdown from "./components/DashboardDownloadDropdown";
import DashboardFocusAreasList from "./components/DashboardFocusAreasList";
import DashboardChipActiveStudents from "./components/DashboardChipActiveStudents";
import DashboardDatePickerRange from "./components/DashboardDatePickerRange";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#040719",
    minHeight: "100%",
    padding: theme.spacing(4),
  },
  headerContainer: {
    minHeight: 80,
  },
  rightHeader: {
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  chartWrapper: {
    position: "relative",
    width: "100%",
  },
  rotatedBg: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  chartContent: {
    position: "relative",
    zIndex: 2,
  },
  section: {
    marginBottom: theme.spacing(5),
  },
  chipsContainer: {
    justifyContent: "flex-end",
  },
}));

const ResponsiveDashboard = ({ school, is_admin }) => {
  const classes = useStyles();
  const [data, setData] = useState({ labels: [], series: [] });

  const { t } = useTraduction();

  useBreakpoints();

  useEffect(() => {
    if (school && school !== null && school.slug) {
      getStudentMoods(school.slug, setData);
    }
  }, [school]);

  return (
    <div className={classes.container}>
      <Grid container spacing={2}>
        <Grid container item xs={12} className={classes.headerContainer}>
          <Grid item xs={9} sm={10}>
            <DashboardTitle
              fontWeight={500}
              fontSize={24}
              text={t("DASHBOARD.DASHBOARD")}
            />
          </Grid>
          <Grid item xs={3} sm={2}>
            <DashboardDownloadDropdown />
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={2} className={classes.section}>
          <Grid item xs={12} md={5}>
            <DashboardTitle
              variant="dark.white"
              fontWeight={300}
              fontSize={24}
              text={t("DASHBOARD.CURRENTLY_VIEWING")}
            />
            <TeamsList />
          </Grid>
          <Grid container item xs={12} md={7} className={classes.rightHeader}>
            <DashboardDatePickerRange />
          </Grid>
        </Grid>

        <Grid item xs={12} md={5} className={classes.section}>
          <DashboardTitle
            variant="dark.white"
            fontWeight={500}
            fontSize={28}
            text={t("DASHBOARD.GENERAL_MOOD")}
          />
          <div className={classes.chartWrapper}>
            <div className={classes.chartContent}>
              <DashboardChart labels={data.labels} series={data.series} />
            </div>
            <div className={classes.rotatedBg}>
              <RotatedBackground />
            </div>
          </div>
          <div className={classes.section}>
            <DashboardCardList />
          </div>
          <TeleHelpNotifications text={t("DASHBOARD.TELEHELP_DRAFTS_SENT")} />
          {is_admin && (
            <TeleHelpNotificationsSentCount
              text={t("DASHBOARD.TELEHELP_SENT_COUNT")}
            />
          )}
          <DashboardTitle
            variant="dark.white"
            fontWeight={500}
            fontSize={28}
            text={t("DASHBOARD.FOCUS_AREAS")}
          />
          <DashboardTitle
            variant="dark.white"
            fontWeight={500}
            fontSize={17}
            text={t("DASHBOARD.TOP_3")}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <DashboardFocusAreasListTop3 />
            </Grid>
            <Grid item xs={12} md={5}>
              <DashboardFocusAreasList />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={7} className={classes.section}>
          <Grid container spacing={3}>
            <Grid container item xs={12} className={classes.chipsContainer}>
              <DashboardChipActiveStudents width={128} />
            </Grid>
            <Grid item xs={12} md={6}>
              <DashboardLibraryList />
            </Grid>
            <Grid item xs={12} md={6}>
              <DashboardUniversityHub />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (store) => ({
  school: store.school.selected_school,
  is_admin: store.auth.user?.is_admin,
});

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveDashboard);
